import { render } from "./AddBankCard.vue?vue&type=template&id=472bbfef&scoped=true"
import script from "./AddBankCard.vue?vue&type=script&lang=js"
export * from "./AddBankCard.vue?vue&type=script&lang=js"

import "./AddBankCard.vue?vue&type=style&index=0&id=472bbfef&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472bbfef"]])

export default __exports__